import { Money } from "models/money";
import { Percentage } from "models/percentage";
import { Unit } from "models/unit";
import {
  is_search_year_2_years_ago,
  is_search_year_current_year,
  is_search_year_last_year,
} from "./utils";

export function getExcelData(analisysResults, selectedData, year, selectedDetailLevel) {
  //selectedDetailLevel: company/manufacturer/category/product/presentation

  let one_year_ago;
  let two_year_ago;
  year = Number(year);

  if (is_search_year_current_year(year)) {
    one_year_ago = year - 1;
    two_year_ago = year - 2;
  }

  if (is_search_year_last_year(year)) {
    one_year_ago = year + 1;
    two_year_ago = year - 1;
  }

  if (is_search_year_2_years_ago(year)) {
    one_year_ago = year + 1;
    two_year_ago = year + 2;
  }

  //  console.log("getExcelData: ", analisysResults);
  let result = [];

  let total_detail_year = 0;
  let total_detail_one_year_ago = 0;
  let total_detail_two_years_ago = 0;

  let total_quater_I = 0;
  let total_quater_II = 0;
  let total_quater_III = 0;
  let total_quater_IV = 0;

  let show_company = ["company", "manufacturer", "product", "presentation"].includes(
    selectedDetailLevel
  );
  let lab_is_present = ["manufacturer", "product", "presentation"].includes(selectedDetailLevel);
  let show_presentation = ["presentation"].includes(selectedDetailLevel);
  let show_category = ["category"].includes(selectedDetailLevel);
  let show_product = ["product"].includes(selectedDetailLevel);

  analisysResults.forEach((elem, index) => {
    let element_to_push = {
      Rank: index + 1,
    };

    if (show_company) {
      element_to_push["Empresa"] = "company" in elem ? elem.company : elem.presentation;
    }

    if (lab_is_present) {
      element_to_push["Laboratorio"] = elem.lab;
    }

    if (show_presentation) {
      element_to_push["Presentacion"] = elem.presentation;
    }

    if (show_category) {
      element_to_push["Categoria"] = elem.presentation;
    }
    if (show_product) {
      element_to_push["Producto"] = elem.presentation;
    }

    //
    // adding years
    //

    if (is_search_year_current_year(year)) {
      element_to_push["Detalles " + two_year_ago] =
        selectedData === "valores" ? Money(elem.detailTwoYearAgo) : Unit(elem.detailTwoYearAgo);

      element_to_push["Detalles " + one_year_ago] =
        selectedData === "valores" ? Money(elem.detailOneYearAgo) : Unit(elem.detailOneYearAgo);

      element_to_push["Detalles " + year] =
        selectedData === "valores" ? Money(elem.detailYear) : Unit(elem.detailYear);
    }

    if (is_search_year_last_year(year)) {
      element_to_push["Detalles " + two_year_ago] =
        selectedData === "valores" ? Money(elem.detailTwoYearAgo) : Unit(elem.detailTwoYearAgo);

      element_to_push["Detalles " + year] =
        selectedData === "valores" ? Money(elem.detailYear) : Unit(elem.detailYear);

      element_to_push["Detalles " + one_year_ago] =
        selectedData === "valores" ? Money(elem.detailOneYearAgo) : Unit(elem.detailOneYearAgo);
    } else {
      element_to_push["Detalles " + year] =
        selectedData === "valores" ? Money(elem.detailYear) : Unit(elem.detailYear);

      element_to_push["Detalles " + one_year_ago] =
        selectedData === "valores" ? Money(elem.detailOneYearAgo) : Unit(elem.detailOneYearAgo);

      element_to_push["Detalles " + two_year_ago] =
        selectedData === "valores" ? Money(elem.detailTwoYearAgo) : Unit(elem.detailTwoYearAgo);
    }

    //
    // adding quarters
    //

    (element_to_push["Detalles Trimestre I"] =
      selectedData === "valores" ? Money(elem.detailFirstQuarter) : Unit(elem.detailFirstQuarter)),
      (element_to_push["Detalles Trimestre II"] =
        selectedData === "valores"
          ? Money(elem.detailSecondQuarter)
          : Unit(elem.detailSecondQuarter)),
      (element_to_push["Detalles Trimestre III"] =
        selectedData === "valores"
          ? Money(elem.detailThirdQuarter)
          : Unit(elem.detailThirdQuarter)),
      (element_to_push["Detalles Trimestre IV"] =
        selectedData === "valores"
          ? Money(elem.detailFourthQuarter)
          : Unit(elem.detailFourthQuarter)),
      //
      // calculate totals
      //

      (total_quater_I += elem.detailFirstQuarter);
    total_quater_II += elem.detailSecondQuarter;
    total_quater_III += elem.detailThirdQuarter;
    total_quater_IV += elem.detailFourthQuarter;

    total_detail_year += elem.detailYear;
    total_detail_one_year_ago += elem.detailOneYearAgo;
    total_detail_two_years_ago += elem.detailTwoYearAgo;

    //
    // adding percentage rate
    //
    if (is_search_year_current_year(year)) {
      element_to_push["Participacion " + two_year_ago] = Percentage(elem.participationTwoYearAgo);
      element_to_push["Participacion " + one_year_ago] = Percentage(elem.participationOneYearAgo);
      element_to_push["Participacion " + year] = Percentage(elem.participationYear);
    }
    if (is_search_year_last_year(year)) {
      element_to_push["Participacion " + two_year_ago] = Percentage(elem.participationTwoYearAgo);
      element_to_push["Participacion " + year] = Percentage(elem.participationYear);
      element_to_push["Participacion " + one_year_ago] = Percentage(elem.participationOneYearAgo);
    } else {
      element_to_push["Participacion " + year] = Percentage(elem.participationYear);
      element_to_push["Participacion " + one_year_ago] = Percentage(elem.participationOneYearAgo);
      element_to_push["Participacion " + two_year_ago] = Percentage(elem.participationTwoYearAgo);
    }

    // Growth rate
    element_to_push["Taza de Crecimiento"] = elem.growthRateYear;

    result.push(element_to_push);
  });
  ////////////////////////////////////////////////////////////////////
  //  ********   Adding totales ********* //
  ////////////////////////////////////////////////////////////////////
  let totales = {
    Rank: "",
  };

  if (show_company) {
    totales["Empresa"] = "TOTALES";
  }

  if (lab_is_present) {
    totales["Laboratorio"] = "";
  }
  if (show_presentation) {
    totales["Presentacion"] = "";
  }
  if (show_category) {
    totales["Categoria"] = "TOTALES";
  }
  if (show_product) {
    totales["Producto"] = "";
  }

  //
  // adding years
  //
  if (is_search_year_current_year(year)) {
    totales["Detalles " + two_year_ago] =
      selectedData === "valores"
        ? Money(total_detail_two_years_ago)
        : Unit(total_detail_two_years_ago);

    totales["Detalles " + one_year_ago] =
      selectedData === "valores"
        ? Money(total_detail_one_year_ago)
        : Unit(total_detail_one_year_ago);

    totales["Detalles " + year] =
      selectedData === "valores" ? Money(total_detail_year) : Unit(total_detail_year);
  }
  if (is_search_year_last_year(year)) {
    totales["Detalles " + two_year_ago] =
      selectedData === "valores"
        ? Money(total_detail_two_years_ago)
        : Unit(total_detail_two_years_ago);

    totales["Detalles " + year] =
      selectedData === "valores" ? Money(total_detail_year) : Unit(total_detail_year);

    totales["Detalles " + one_year_ago] =
      selectedData === "valores"
        ? Money(total_detail_one_year_ago)
        : Unit(total_detail_one_year_ago);
  } else {
    totales["Detalles " + year] =
      selectedData === "valores" ? Money(total_detail_year) : Unit(total_detail_year);

    totales["Detalles " + one_year_ago] =
      selectedData === "valores"
        ? Money(total_detail_one_year_ago)
        : Unit(total_detail_one_year_ago);

    totales["Detalles " + two_year_ago] =
      selectedData === "valores"
        ? Money(total_detail_two_years_ago)
        : Unit(total_detail_two_years_ago);
  }
  //
  // adding quarters
  //

  totales["Detalles Trimestre I"] =
    selectedData === "valores" ? Money(total_quater_I) : Unit(total_quater_I);
  totales["Detalles Trimestre II"] =
    selectedData === "valores" ? Money(total_quater_II) : Unit(total_quater_II);
  totales["Detalles Trimestre III"] =
    selectedData === "valores" ? Money(total_quater_III) : Unit(total_quater_III);
  totales["Detalles Trimestre IV"] =
    selectedData === "valores" ? Money(total_quater_IV) : Unit(total_quater_IV);
  //
  //adding percentage rate
  //
  if (is_search_year_current_year(year)) {
    totales["Participacion " + two_year_ago] = Percentage(100);
    totales["Participacion " + one_year_ago] = Percentage(100);
    totales["Participacion " + year] = Percentage(100);
  }
  if (is_search_year_last_year(year)) {
    totales["Participacion " + two_year_ago] = Percentage(100);
    totales["Participacion " + year] = Percentage(100);
    totales["Participacion " + one_year_ago] = Percentage(100);
  } else {
    totales["Participacion " + year] = Percentage(100);
    totales["Participacion " + one_year_ago] = Percentage(100);
    totales["Participacion " + two_year_ago] = Percentage(100);
  }

  totales["Taza de Crecimiento"] = "";

  result.push(totales);

  return result;
}
